import React from "react";
import Marquee from "react-fast-marquee";

const MarqueeComponent = ({ images }) => {
  return (
    <div className="w-full overflow-hidden py-10 bg-white  rounded-lg">
      <Marquee gradient={false} speed={100}>
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Marquee Image ${index + 1}`}
            className="w-40 h-40 object-contain mx-4 rounded-lg"
          />
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeComponent;
